<pdq-card variant="popover" color="white">
  <div class="card">
    <div class="card__header">
      <div class="card__header__text">
        <pdq-heading element="h5">Components</pdq-heading>
        <span class="card__subtitle">Toggle and reorder the building blocks of your delivery promise</span>
      </div>
    </div>
    <pdq-divider></pdq-divider>
    <div class="card__content">
      <div cdkDropList (cdkDropListDropped)="onDrop($event)" class="components-list">
        @for (componentForm of components.controls; track componentForm.get('id')?.value; let i = $index) {
          <div cdkDrag class="component-row">
            <div class="component-row__main">
              <pdq-drag-and-drop cdkDragHandle spacing="tight"></pdq-drag-and-drop>
              <div class="component-row__body">
                <div class="component-row__title">
                  {{ componentMeta[componentForm.get('type').value].title }}
                </div>
                <div class="component-row__subtitle">
                  {{ componentMeta[componentForm.get('type').value].subtitle }}
                </div>
                @if (componentForm.invalid) {
                  <div class="component-row__error">*Missing required field</div>
                }
              </div>
              @if (componentForm.get('type').value === LayoutComponentType.LINE_SEPARATOR) {
                <button
                  type="button"
                  class="component-row__trash-btn"
                  (click)="removeComponent(i); $event.stopPropagation()"
                  aria-label="Remove line separator">
                  <pdq-icon icon="trash" color="var(--error-default)"></pdq-icon>
                </button>
              } @else {
                <pdq-slide-toggle
                  [formControl]="componentForm.get('enabled')"
                  [disabled]="componentForm.get('type').value === LayoutComponentType.DELIVERY_DATE">
                </pdq-slide-toggle>
                <button
                  type="button"
                  class="component-row__chevron-btn"
                  (click)="toggleExpanded(componentForm.get('id').value)">
                  <pdq-icon
                    class="component-row__chevron"
                    [icon]="
                      expandedId === componentForm.get('id').value ? 'collapsing-arrow-up' : 'collaping-arrow-down'
                    "></pdq-icon>
                </button>
              }
            </div>
            @if (
              expandedId === componentForm.get('id').value &&
              componentForm.get('type').value !== LayoutComponentType.LINE_SEPARATOR
            ) {
              <div class="component-row__editor">
                @switch (componentForm.get('type').value) {
                  @case (LayoutComponentType.LABEL) {
                    <label-component-editor [componentForm]="componentForm"></label-component-editor>
                  }
                  @case (LayoutComponentType.DELIVERY_DATE) {
                    <delivery-date-component-editor [componentForm]="componentForm"></delivery-date-component-editor>
                  }
                  @case (LayoutComponentType.SHIPPING_METHOD_LINE) {
                    <shipping-method-line-component-editor
                      [componentForm]="componentForm"></shipping-method-line-component-editor>
                  }
                  @case (LayoutComponentType.LOCATION_INPUT) {
                    <location-input-component-editor [componentForm]="componentForm"></location-input-component-editor>
                  }
                  @case (LayoutComponentType.CUTOFF_TIMER) {
                    <cutoff-timer-component-editor [componentForm]="componentForm"></cutoff-timer-component-editor>
                  }
                  @case (LayoutComponentType.TRUST_SIGNALS) {
                    <trust-signals-component-editor [componentForm]="componentForm"></trust-signals-component-editor>
                  }
                }
              </div>
            }
          </div>
        }
      </div>
      <button type="button" class="add-separator-btn" (click)="addLineSeparator()">
        <pdq-icon icon="Plus" size="small" color="var(--secondary-default)"></pdq-icon>
        <span>Add Line separator</span>
      </button>
    </div>
  </div>
</pdq-card>
